import React, { PropsWithChildren } from "react";
import { Paper, Slide } from "@mui/material";
import { CssHeight, CssWidth } from "../../types/UtilityTypes/UtilityTypes";
import collapsableWindowStyles from "./collapsableWindowStyles";

export type CollapsableWindowProps = {
  windowState: "minimized" | "maximized" | null;
  width?: CssWidth;
  height?: CssHeight;
};

export default function CollapsableWindow({
  windowState,
  width = "32rem",
  height = "85vh",
  children,
}: PropsWithChildren<CollapsableWindowProps>) {
  return (
    <Slide direction={"up"} in={!!windowState}>
      <Paper
        sx={{
          ...collapsableWindowStyles.paper,
          width: { xs: "auto", sm: width },
          height: windowState === "minimized" ? "4rem" : height,
        }}
      >
        {children}
      </Paper>
    </Slide>
  );
}
